import { Stack, Typography, Tooltip, IconButton } from "@mui/material";
import { useCallback } from "react";
import { useTranslateTextMutation } from "src/api/services/translateApi";
import { Answer } from "src/api/types";
import { theme } from "src/assets/theme";
import TranslateIcon from "@mui/icons-material/Translate";

interface Props {
  answer: Answer;
  index: number;
}

const AnswerView = ({ answer, index }: Props) => {
  const [translateText, { data, isLoading }] = useTranslateTextMutation();

  const handleTranslate = useCallback(() => {
    translateText({
      text: answer.response.answer.join(", "),
      target_language: "en-US",
    });
  }, [answer.response.answer, translateText]);

  return (
    <Stack
      key={answer.question_id}
      gap={1}
      p={1}
      borderBottom="1px solid black"
      borderTop={index === 0 ? "1px solid black" : undefined}
    >
      <Typography variant="body2">{answer.question.title}</Typography>
      {answer.question_type === "multiple_choice" && answer.question.options
        ? answer.question.options.map((o, index) => {
            const selectedChoice = answer.response.answer.includes(o.value);

            return (
              <Typography
                key={index}
                fontStyle="italic"
                alignSelf="end"
                variant="body2"
                fontWeight={selectedChoice ? 600 : 500}
                p={selectedChoice ? 0.5 : 0}
                sx={{
                  border: selectedChoice ? `#1E90FF 2px solid` : "",
                  borderRadius: "10px",
                  textDecoration: selectedChoice ? "" : "line-through",
                }}
              >
                {o.label}
              </Typography>
            );
          })
        : null}
      {answer.question_type !== "multiple_choice" ? (
        <Stack alignItems="flex-end">
          <Stack
            gap={1}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Typography
              textAlign="right"
              fontStyle="italic"
              variant="body2"
              fontWeight={600}
            >
              {answer.response.answer.join(", ")}
              {answer.response.details
                ? `, ${answer.response.details}`
                : undefined}
            </Typography>
            {answer.question_type === "text" ? (
              <Tooltip title="Translate">
                <IconButton
                  loading={isLoading}
                  sx={{ alignSelf: "center" }}
                  size="small"
                  onClick={handleTranslate}
                >
                  <TranslateIcon />
                </IconButton>
              </Tooltip>
            ) : null}
          </Stack>
          {data != null ? (
            <Typography variant="body2" color={theme.palette.secondary.dark}>
              {data.text}
            </Typography>
          ) : null}
        </Stack>
      ) : null}
    </Stack>
  );
};

export default AnswerView;
